import { CloseOutlined, SaveOutlined } from "@ant-design/icons";
import { Button, Space, message } from "antd";
import MultiPane from "@components/tabs-responsive/tabs-responsive";
import { useEffect, useState } from "react";
import { serverFetch } from "../../server";
import { useViewportBreakpoint } from "../../hooks/useViewportBreakpoint";
import "../company/company.css";
import "./license-order.css";
import LicenseOrderKeys from "./license-order-keys";
import LicenseOrderMain from "./license-order-main";

const LicenseOrder = ({ companyId, accId, onClose }) => {
  const isMobile = useViewportBreakpoint() === "mobile";
  const [orderData, setOrderData] = useState(null);
  const [mobileToolbar, setMobileToolbar] = useState(null);
  const [tabKey, setTabKey] = useState("order");

  const getData = () => {
    if (!companyId || !accId) return;

    serverFetch(`license/order?companyId=${companyId}&accId=${accId}`)
      .then(data => {
        setOrderData(data);
      })
      .catch(e => {
        message.error(e.userMessage);
      });
  };

  useEffect(() => {
    if (companyId && accId) {
      getData();
    }
  }, [companyId, accId]);

  useEffect(() => {
    setTabKey("order");
  }, [companyId, accId]);

  const handleOrderUpdate = updatedData => {
    setOrderData(updatedData);
  };

  const handleClose = refresh => {
    onClose(refresh);
  };

  const orderMainEl = (
    <LicenseOrderMain
      companyId={companyId}
      accId={accId}
      onUpdate={handleOrderUpdate}
      onClose={handleClose}
      isMobile={isMobile}
      onMobileToolbarState={isMobile ? setMobileToolbar : undefined}
    />
  );

  const paneItems =
    accId === 0
      ? [{ key: "order", label: "Заказ", children: orderMainEl }]
      : [
          { key: "order", label: "Заказ", children: orderMainEl },
          {
            key: "keys",
            label: "Ключи",
            children: (
              <LicenseOrderKeys companyId={companyId} accId={accId} onClose={() => {}} />
            ),
          },
        ];

  const tabsEl = (
    <MultiPane
      className={isMobile ? "license-order-modal-tabs" : undefined}
      activeKey={tabKey}
      onChange={setTabKey}
      items={paneItems}
      type="card"
    />
  );

  const titleText = `Заказ #${companyId} / ${accId}`;

  if (isMobile) {
    return (
      <div
        className="misoft-modal-overlay company-base-overlay--mobile"
        onClick={e => e.target === e.currentTarget && handleClose(false)}
      >
        <div className="misoft-modal-content company-base-sheet--mobile" onClick={e => e.stopPropagation()}>
          <div className="company-base-sheet-header">
            <span className="company-base-sheet-title">{titleText}</span>
            <Space size="small" className="company-base-sheet-actions">
              {tabKey === "order" && mobileToolbar ? (
                <Button
                  type="primary"
                  icon={<SaveOutlined />}
                  onClick={() => mobileToolbar.save()}
                  loading={mobileToolbar.loading}
                  disabled={mobileToolbar.saveDisabled}
                  aria-label="Сохранить"
                  className="company-base-header-icon-btn"
                />
              ) : null}
              <Button
                type="default"
                icon={<CloseOutlined />}
                onClick={() => handleClose(false)}
                aria-label="Закрыть"
                className="company-base-header-icon-btn"
              />
            </Space>
          </div>
          <div className="company-base-sheet-body">{tabsEl}</div>
        </div>
      </div>
    );
  }

  return (
    <>
      <div className="cloud-modal-overlay" onClick={() => handleClose(false)} />
      <div className="cloud-modal-license-order-keys">
        <div className="cloud-modal-header">
          <h3>{titleText}</h3>
          <Button onClick={() => handleClose(false)} type="text">
            ×
          </Button>
        </div>
        <div className="cloud-modal-content">{tabsEl}</div>
      </div>
    </>
  );
};

export default LicenseOrder;
